import React, { useEffect } from 'react'

import "./Products.css"
import FilterProducts from '../../Components/FilterProducts/FilterProducts'
import ProductsList from '../../Components/ProductsList/ProductsList'
import SideBarComponent from '../../Components/SideBarComponent/SideBarComponent'
import ProductsListAdmin from '../../Components/ProductsList/ProductListAdmin'
import SideBarDeskComponent from '../../Components/SideBarComponent/SideBarDeskComponent'

const ProductsAdmin = () => {
    const [loading, setLoading] = React.useState<boolean>(true);
    const [filterCategory, setFilterCategory] = React.useState<string[]>([]);
    const [filterTCG, setFilterTCG] = React.useState<string[]>([]);
    const [filterTipo, setFilterTipo] = React.useState<string[]>([]);
    const [filterIdioma, setFilterIdioma] = React.useState<string[]>([]);

    const [openResponsiveFilters, setOpenResponsiveFilters] = React.useState<boolean>(false);

  
  return (
    <>
    <SideBarDeskComponent open={openResponsiveFilters} setOpen={setOpenResponsiveFilters}>
      <FilterProducts filterCategory={filterCategory} setFilterCategory={setFilterCategory} loading={loading} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} setFilterIdioma={setFilterIdioma} setFilterTCG={setFilterTCG} setFilterTipo={setFilterTipo} />
    </SideBarDeskComponent>
    
    <div className=''>
        <div className='Products-Section'>
            {/* <div className='Products-Filter-section'>
                <FilterProducts filterCategory={filterCategory} setFilterCategory={setFilterCategory} loading={loading} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} setFilterIdioma={setFilterIdioma} setFilterTCG={setFilterTCG} setFilterTipo={setFilterTipo} />

            </div> */}

            <div className='Products-filter-listAdmin'>
              <ProductsListAdmin filterCategory={filterCategory} setFilterOpen={setOpenResponsiveFilters} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} type='disponibles' loading={loading} setLoading={setLoading} ></ProductsListAdmin>
            </div>
        </div>
    </div>
    </>

  )
}

export default ProductsAdmin